export const GeneratePassword = (nroCharacter: number) => {
  let newPassword = "";
  const characters = "abcdefghijklmnopqrstuvwxyz1234567890";
  for(let i = 0; i < nroCharacter; i++) {
      newPassword += characters[Math.floor(Math.random() * characters.length)];
  }
  return newPassword;
}